import React from 'react';

import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';
import Content from 'components/sidebar/components/Content';
import {
  renderThumb,
  renderTrack,
  renderSidebarView,
  renderView,
} from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import PropTypes from 'prop-types';

import { IoMenuOutline } from 'react-icons/io5';

function Sidebar(props) {
  const { routes, collapsed } = props;

  const variantChange = '0.3s ease';
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.08)',
    'unset',
  );
  const sidebarBg = useColorModeValue('white', 'navy.800');

  return (
    <Box
      display={{ sm: 'none', xl: 'block' }}
      position="fixed"
      top={0}
      left={0}
      w={collapsed ? '70px' : '300px'}
      h="100vh"
      zIndex={1100}
      pointerEvents="none"
    >
      <Box
        bg={sidebarBg}
        transition={variantChange}
        w="100%"
        h="100vh"
        minH="100%"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        boxShadow={shadow}
        pointerEvents="auto"
      >
        <Box
          flex="1"
          minH={0}
          overflow={collapsed ? 'auto' : 'hidden'}
          overflowX="hidden"
          w="100%"
        >
          {collapsed ? (
            <Flex justify="center" w="100%">
              <Content routes={routes} collapsed={collapsed} />
            </Flex>
          ) : (
            <Scrollbars
              autoHide
              style={{ height: '100%' }}
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderSidebarView}
            >
              <Content routes={routes} collapsed={collapsed} />
            </Scrollbars>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export function SidebarResponsive(props) {
  const sidebarBackgroundColor = useColorModeValue('white', 'navy.800');
  const menuColor = useColorModeValue('gray.400', 'white');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const { routes, sidebarCollapsed, setSidebarCollapsed } = props;

  const handleToggle = () => {
    if (window.innerWidth >= 1280) {
      setSidebarCollapsed && setSidebarCollapsed(!sidebarCollapsed);
    } else {
      onOpen();
    }
  };

  return (
    <Flex display={{ sm: 'flex', xl: 'flex' }} alignItems="center">
      <Flex ref={btnRef} w="max-content" h="max-content" onClick={handleToggle}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my="auto"
          w="20px"
          h="20px"
          me="10px"
          _hover={{ cursor: 'pointer' }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent w="285px" maxW="285px" bg={sidebarBackgroundColor}>
          <DrawerCloseButton
            zIndex="3"
            onClose={onClose}
            _focus={{ boxShadow: 'none' }}
            _hover={{ boxShadow: 'none' }}
          />
          <DrawerBody maxW="285px" px="0" pb="0">
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Content routes={routes} collapsed={false} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};

export default Sidebar;
